module.exports = __webpack_public_path__ + "img/songhuadan.2e51d7a1.png";